(function () {
    'use strict';

    angular
        .module('Lavpop-store.services')
        .service('ModuleService', ModuleService)

    /** @ngInject */
    function ModuleService(HttpService) {
        const ModuleService = {
            getAll: getAll
        }

        return ModuleService;

        function getAll() {
            return HttpService.get('/modules');
        }
    }
}());